var map = {
	"./ico-bz.png": 922,
	"./ico-fb.png": 923,
	"./ico-gp.png": 924,
	"./ico-insta.png": 925,
	"./ico-pi.png": 926,
	"./ico-snapchat.png": 927,
	"./ico-t.png": 928,
	"./ico-tw.png": 929,
	"./ico-yt.png": 930
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 921;


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/social_icons ^\.\/.*$
// module id = 921
// module chunks = 4